/**
 * Подписка на медиазапрос.
 *
 * Нужна там, где от размера экрана зависит поведение, а не оформление:
 * плавающую панель на телефоне не потаскаешь, и включать перетаскивание там
 * бессмысленно. Оформлению хук не нужен — для него есть классы.
 *
 * Сделано через useSyncExternalStore: matchMedia — внешний источник, и React
 * умеет подписываться на такие сам, без эффекта, который дёргает setState
 * и вызывает лишний рендер.
 */
import { useCallback, useSyncExternalStore } from "react";

export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (notify: () => void) => {
      const media = window.matchMedia(query);
      media.addEventListener("change", notify);
      return () => media.removeEventListener("change", notify);
    },
    [query],
  );

  const value = useCallback(() => window.matchMedia(query).matches, [query]);

  // На сервере окна нет; сборка статическая, но значение по умолчанию должно
  // быть определено — считаем экран узким и не включаем перетаскивание.
  return useSyncExternalStore(subscribe, value, () => false);
}
